module.exports = __webpack_public_path__ + "static/media/Engine Digital.b1299a8e.png";